module.exports = __webpack_public_path__ + "static/media/dokia-login.1fd8a595.svg";